import { MappedClass, MappedPropertyArray, MappedPropertyClass } from '@h5s/util-object';
import { ZPrinterPosHealthEntry } from './z-printer-pos-health-entry';
import { ZPrinterPrinterHealthEntry } from './z-printer-printer-health-entry';
import { ZPrinterSettingsHealthEntry } from './z-printer-settings-health-entry';
import { ZPrinterWorkerHealthEntry } from './z-printer-worker-health-entry';

@MappedClass()
export class ZPrinterHealthChecks {
  @MappedPropertyArray(() => ZPrinterPosHealthEntry)
  pos?: ZPrinterPosHealthEntry[];

  @MappedPropertyArray(() => ZPrinterPrinterHealthEntry)
  printers?: ZPrinterPrinterHealthEntry[];

  @MappedPropertyClass(() => ZPrinterSettingsHealthEntry)
  settings?: ZPrinterSettingsHealthEntry;

  @MappedPropertyArray(() => ZPrinterWorkerHealthEntry)
  workers?: ZPrinterWorkerHealthEntry[];
}
